<template>
  <div>
    <div v-if="ChooseImageActive" class="box-active-image-cut-face">
      <div class="custom-image">
        <img
          :src="ChangeImgUrl"
          @click="handleOnShowAsk"
        />
        <button type="button" class="btn btn-settting-cut-face" @click="handleOnShowAsk">
          <v-icon style="width: 20px" name="settings"></v-icon>
        </button>
      </div>
    </div>
    <div v-if="!ChooseImageActive">
      <button  v-bind:class="{ choose_image_shape_active: ChooseImageShapeActive }" type="button" @click="showFileChooser" class="btn btn-upload-shape-image">
        Select image
      </button>
    </div>

    <modal
      :name="modalAsk"
      :adaptive="true"
      height="auto"
      width="500"
      :clickToClose="true"
      :reset="true"
      class='Modal_ask_box'
    >
      <div class="box-modal-ask">
        <div @click="hideModalAsk" class="box-modal-ask-close">&#10005;</div>
        <p class="modal-ask-text">Please choose your action!</p>
        <div class="group_ask_button">
          <button @click="showFileChooser" class='btn btn_ask_change'>
            <v-icon style="width: 20px" name="refresh-cw"></v-icon> Change
          </button>
          <button @click="OnShowSetting" class='btn btn_ask_edit'>
            <v-icon style="width: 20px" name="crop"></v-icon> Edit
          </button>
        </div>
      </div>
    </modal>

    <modal
      :name="modalDragName"
      :adaptive="true"
      height="auto"
      width="1000"
      :clickToClose="true"
      :reset="true"
      @closed="hideDragModal"
      class='Modal_box model-cut-face'
    >
      <div @click="hideDragModal" class="Abn-modal-close">&#10005;</div>
      <div class="box-container-modal-cutface">
        <div ref="box_preview">
          <PreviewPrintMockups
            :name_layer="context.name"
            class="preview-print"
            @setScaleNow="setScaleNow"
            @onChangeConfigImage="onChangeConfigImage"
          />
          <!-- <preview-print
            :name_layer="context.name"
            class="preview-print"
            @setScaleNow="setScaleNow"
            @onChangeConfigImage="onChangeConfigImage"
          /> -->
        </div>
        <div class="box-controller-mobile">
          <div class="box-setting-cut-face">

          </div>
          <div class="box-setting-cut-face_column__item">
            <div>
              <label>Position: </label>
              <div class="box-position-adjustment">
                <button
                  class="btn btn-flip-face po-left"
                  @mousedown="OnMouseDownLeft"
                  @mouseup="OnMouseUpLeft"
                  @touchstart="OnMouseDownLeft"
                  @touchend="OnMouseUpLeft"
                  @click="handleSetLeft">
                  <v-icon style="width: 20px" name="arrow-left"></v-icon>
                </button>
                <button
                  class="btn btn-flip-face po-right"
                  @mousedown="OnMouseDownRight"
                  @mouseup="OnMouseUpRight"
                  @touchstart="OnMouseDownRight"
                  @touchend="OnMouseUpRight"
                  @click="handleSetRight">
                  <v-icon style="width: 20px" name="arrow-right"></v-icon>
                </button>
                <button
                  class="btn btn-flip-face po-top"
                  @mousedown="OnMouseDownTop"
                  @mouseup="OnMouseUpTop"
                  @touchstart="OnMouseDownTop"
                  @touchend="OnMouseUpTop"
                  @click="handleSetTop">
                  <v-icon style="width: 20px" name="arrow-up"></v-icon>
                </button>
                <button
                  class="btn btn-flip-face po-bottom"
                  @mousedown="OnMouseDownBottom"
                  @mouseup="OnMouseUpBottom"
                  @touchstart="OnMouseDownBottom"
                  @touchend="OnMouseUpBottom"
                  @click="handleSetBottom">
                  <v-icon style="width: 20px" name="arrow-down"></v-icon>
                </button>
              </div>
              <label>Flip: </label>
              <div class="box-position-adjustment">
                <button v-if="defaultFlip" class="btn btn-flip-face" @click="handleFlip"><v-icon style="width: 20px" name="corner-up-left"></v-icon></button>
                <button v-else class="btn btn-flip-face" @click="handleFlip"><v-icon style="width: 20px" name="corner-up-right"></v-icon></button>
              </div>
              <label>Rotation: </label>
              <div class="box-position-adjustment">
                <button
                  class="btn btn-flip-face po-right"
                  @mousedown="OnMouseDownRotation"
                  @mouseup="OnMouseUpRotation"
                  @touchstart="OnMouseDownRotation"
                  @touchend="OnMouseUpRotation"
                  @click="handleSetRotation">
                  <v-icon style="width: 20px" name="rotate-ccw"></v-icon>
                </button>
              </div>
              <label>Zoom: </label>
              <div class="box-position-adjustment">
                <button
                  class="btn btn-flip-face po-right"
                  @mousedown="OnMouseDownZoomMax"
                  @mouseup="OnMouseUpZoomMax"
                  @touchstart="OnMouseDownZoomMax"
                  @touchend="OnMouseUpZoomMax"
                  @click="handleSetZoomMax">
                  <v-icon style="width: 20px" name="maximize-2"></v-icon>
                </button>
                <button
                  class="btn btn-flip-face po-right"
                  @mousedown="OnMouseDownZoomMin"
                  @mouseup="OnMouseUpZoomMin"
                  @touchstart="OnMouseDownZoomMin"
                  @touchend="OnMouseUpZoomMin"
                  @click="handleSetZoomMin">
                  <v-icon style="width: 20px" name="minimize-2"></v-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="Abn-modal-footer">
        <div class="Abn-modal-footer-div">
          <button type="button" @click="hideDragModal" class="btn Abn-btn-cancel">Cancel</button>
          <button type="button" class="btn Abn-btn-apply" @click="ButtonApply">Apply</button>
        </div>
      </div>
    </modal>

    <input
      ref="input"
      type="file"
      name="image"
      accept="image/*"
      @change="setImage"
    />

  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import axios from 'axios';
import { ASSET_URL, CDN_URL, URL_API_IMAGES_REMOVE_BACKGROUND } from '@/config.js';
import { mapGetters, mapMutations } from 'vuex';
import { Buffer } from 'buffer'
import PreviewPrint from '../PreviewArtwork/PreviewPrint'
import PreviewPrintMockups from '../PreviewMockups/PreviewPrintMockups'
import {get} from 'lodash'

export default {
  name: 'ImageRemoveBackground',
  data(){
    return {
      ChooseImageActive: false,
      ChooseImageShapeActive: false,
      messageLoading: false,
      imgData: null,
      OnCropStatus: false,
      ChangeImgUrl: null,
      scaleNow: 1,
      rotationValue: 0,
      zoomValue: 1,
      layerX: 0,
      layerY: 0,
      OnSetting: false,
      base64Img: null,
      defaultFlip: true,
      urlNoneFlip: null,
      urlFlip: null,
      MouseLeft: null,
      MouseRight: null,
      MouseTop: null,
      MouseBottom: null,
      MouseRotation: null,
      MouseZoomMax: null,
      MouseZoomMin: null,
      artworksDefault: null,
      isApplyingChanges: false,
    }
  },
  components: {
    VueCropper, PreviewPrint, PreviewPrintMockups
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    aspectRatio: {
      type: Number,
      default() {
        return 1
      }
    },
    name: {
      type: String,
      default(){
        return ''
      }
    },
    width: {
      type: Number,
      default(){
        return 1000;
      }
    },
    rotation: {
      type: Number,
      default(){
        return 1;
      }
    },
    height: {
      type: Number,
      default(){
        return 1;
      }
    },
    x: {
      type: Number,
      default(){
        return 1
      }
    },
    y: {
      type: Number,
      default(){
        return 1
      }
    },
    layer: {
      type: Object,
      default(){
        return {}
      }
    }
  },
  computed: {
    modalDragName() {
      return `drag-${this.uniqueID(10)}`
    },
    modalAsk() {
      return `ask-${this.uniqueID(10)}`
    },
    localStorageName(){
      return this.context.name + '_' + this.product().id;
    }
  },
  created() {
    this.rotationValue = this.rotation;
    this.layerX = this.x;
    this.layerY = this.y;
  },
  mounted() {
    window.addEventListener('mouseup', this.stopAllHolds);
    window.addEventListener('touchend', this.stopAllHolds);
  },
  beforeDestroy() {
    window.removeEventListener('mouseup', this.stopAllHolds);
    window.removeEventListener('touchend', this.stopAllHolds);
    this.stopAllHolds();
  },
  watch: {
    context(value){
      const model = value.model || {};
      const key = get(model, 'key', null);
      if(key && key.indexOf('upload-custom') >= 0){
        this.ChangeImgUrl = ASSET_URL + '/' + key;
        this.ChooseImageActive = true;
      }
      const geometryProps = ['x', 'y', 'width', 'height', 'scaleX', 'scaleY', 'rotation', 'offsetX', 'offsetY'];
      const data = geometryProps
        .filter(prop => model[prop] !== undefined && model[prop] !== null)
        .map(prop => ({ name: prop, value: model[prop] }));

      if(data.length){
        let artworks = this.artworks();
        const arr = artworks[0].templates[0].layers;
        this.handleSetDataLayer(arr, this.layer.id, data);
        const byName = name => data.find(d => d.name === name);
        if(byName('x')) this.layerX = byName('x').value;
        if(byName('y')) this.layerY = byName('y').value;
        if(byName('rotation')) this.rotationValue = byName('rotation').value;
      }
    },
  },
  methods: {
    ...mapGetters([
      'product',
      'platform',
      'getCartData',
      'artworks',
      'ratio'
    ]),
    ...mapMutations([
      'setCartDataByKey',
      'setArtworks',
      'setMessageError',
      'setLoadingForm',
      'setIsSaveLocalstorage'
    ]),
    showFileChooser(){
      this.$modal.hide(this.modalAsk)
      this.$refs.input.click()
    },
    hideModalAsk(){
      this.$modal.hide(this.modalAsk)
    },
    OnShowSetting(){
      this.$modal.hide(this.modalAsk)
      this.$modal.show(this.modalDragName);
    },
    hideDragModal(){
      if(this.isApplyingChanges){
        this.isApplyingChanges = false;
        this.$modal.hide(this.modalDragName);
        return;
      }
      let artworks = this.artworks();
      let arr = artworks[0].templates[0].layers;
      let layer = this.layer;
      if (layer.id == this.context.name) {
        const artworksDefault = this.artworksDefault;
        let data = [];
        for (const key in artworksDefault) {
          const dataItem = {
            name: key,
            value: artworksDefault[key]
          }
          data = [...data, dataItem];
        }
        this.handleSetDataLayer(arr, layer.id, data);
      }
      this.$modal.hide(this.modalDragName);
    },
    setArtworksDefault(){
      let layer = this.layer;
      if (layer.id == this.context.name) {
        let config = {};
        var props = [
          'x',
          'y',
          'width',
          'height',
          'scaleX',
          'scaleY',
          'rotation',
          'offsetX',
          'offsetY',
        ];
        props.forEach(key => {
          if(layer[key]){
            config[key] = layer[key];
          }
          if(key == 'rotation'){
            config[key] = layer['rotation'];
          }
        });
        this.artworksDefault = config;
      }
    },
    onChangeConfigImage(config){
      let artworks = this.artworks();
      let arr = artworks[0].templates[0].layers;
      let layer = this.layer;
      if (layer.id === config.id) {
        const configs = config.configs;
        var scaleProps = [
          'x',
          'y',
          'width',
          'height',
          'cropX',
          'cropY',
          'cropHeight',
          'cropWidth'
        ];
        scaleProps.forEach(key => {
          if(configs[key]){
            configs[key] = configs[key] / config.scale
          }
        });
        let data = [];
        for (var key in configs){
          const itemData = {
            name: key,
            value: configs[key]
          }
          data = [...data, itemData];
          if(key == 'x'){
            this.layerX = configs[key];
          }else if(key == 'y'){
            this.layerY = configs[key]
          }else if(key == 'rotation'){
            this.rotationValue = configs[key];
          }
        }
        this.handleSetDataLayer(arr, layer.id, data);
      }
    },
    handleOnShowAsk(){
      this.$modal.show(this.modalAsk)
    },
    ButtonApply(){
      this.isApplyingChanges = true;
      this.setArtworksDefault();
      this.syncModelGeometry();
      this.$modal.hide(this.modalDragName);
    },
     setWidthHeightImg(base64){
      const OnThis = this;
      return new Promise((resolve) => {
        var i = new Image();
        i.onload = function(){
          let artworks = OnThis.artworks();
          const arr = artworks[0].templates[0].layers;
          let layer = OnThis.layer;
          const width = layer.width;
          const height = width * (i.height / i.width);

          const data = [
            {
              name: 'width',
              value: width
            },
            {
              name: 'height',
              value: height
            },
            {
              name: 'scaleX',
              value: 1
            },
            {
              name: 'scaleY',
              value: 1
            }
          ]
          OnThis.handleSetDataLayer(arr, layer.id, data);
          resolve();
        };
        i.src = base64;
      });
    },
    syncModelGeometry(){
      const layer = this.layer;
      this.context.model = {
        ...this.context.model,
        x: layer.x,
        y: layer.y,
        width: layer.width,
        height: layer.height,
        scaleX: layer.scaleX,
        scaleY: layer.scaleY,
        rotation: layer.rotation,
        offsetX: layer.offsetX,
        offsetY: layer.offsetY
      };
    },
    setImage(e){
      this.setLoadingForm(true);
      const OnThis = this;
      if(e.target.files.length > 0){
        const file = e.target.files[0];
        const type =  file.type;
        let checkType = false;
        if(type.indexOf('jpeg') >= 0){
          checkType = true;
        }else if(type.indexOf('png') >= 0){
          checkType = true;
        }
        if(checkType){
          this.file = file;
          const reader = new FileReader();
          reader.addEventListener("load", async () => {
            const up = await this.upload(reader.result);
            if(up.status){
              OnThis.setCartDataByKey({
                key: OnThis.localStorageName,
                name: OnThis.context.label,
                value: ASSET_URL + '/' + up.key
              });
              const OnonThis = OnThis;
              
              try{
                const SendRemoveApi = await fetch(URL_API_IMAGES_REMOVE_BACKGROUND, {
                  method: 'post',
                  headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-ABN-KEY': 'rb_YH8SPW4TPTwuaJ7osvcZB13wlqqWHKslF7f7-s558e4'
                  },
                  body: JSON.stringify({
                    image_url: ASSET_URL + '/' + up.key
                  })
                });
                const resRemoveApi = await SendRemoveApi.json();
                const FileKey = resRemoveApi.url;
                const file = {
                  id: OnonThis.context.name,
                  key: FileKey
                }
                OnonThis.ChangeImgUrl = ASSET_URL + '/' + FileKey;
                OnonThis.urlNoneFlip = ASSET_URL + '/' + FileKey;
                OnonThis.setIsSaveLocalstorage(true);
                OnonThis.context.model = file;
                OnonThis.urlFlip = null;
                await OnThis.setWidthHeightImg(await OnonThis.urlToBase64(ASSET_URL + '/' + FileKey))
                OnonThis.setArtworksDefault();
                OnonThis.syncModelGeometry();
                OnonThis.ChooseImageActive = true;
                OnonThis.ChooseImageShapeActive = true;
                OnonThis.$modal.show(this.modalDragName);
                OnonThis.setLoadingForm(false);
                e.target.files = null;
              }catch(err) {
                OnonThis.setLoadingForm(false);
                this.setMessageError(true);
              }
            }
          }, false);
          reader.readAsDataURL(this.file);
        }else {
          alert('Please select an image file');
          this.setLoadingForm(false);
        }
      }else {
        this.setLoadingForm(false);
      }
    },
    async onCrop() {
      this.setLoadingForm(true)
      this.UrlImageUpload = this.$refs.cropper.getCroppedCanvas().toDataURL('image/jpeg');
      this.OnCrop = true
      this.setLoadingForm(false)
    },
    async upload(base64) {
      var file = await fetch(base64)
        .then(res => res.arrayBuffer())
        .then(buf => new File([buf], 'tmp.png', { type: 'image/png' }))
      var signedUrl = await this.getSignedUrl(file.type)
      const pull = await axios
        .put(signedUrl.url, file, {
          headers: {
            'Content-Type': file.type
          }
        })
        .catch(err => console.error(err))
      if(pull.status === 200){
        return {
          status: true,
          key: signedUrl.key
        }
      }else {
        return {
          status: false
        }
      }
    },
    setScaleNow(v){
      this.scaleNow = v;
    },
    async getSignedUrl(mime) {
      var headers = new Headers()
      headers.append('Content-Type', 'application/json')
      var requestOptions = {
        method: 'GET',
        headers: headers,
        redirect: 'follow'
      }
      var signedUrl = null
      await fetch(
        `${this.$options.AWS_API}/signedUrl?type=${mime}`,
        requestOptions
      )
        .then(response => response.json())
        .then(res => (signedUrl = res))
        .catch(err => console.error(err))
      return signedUrl
    },
    zoom(e) {
      if (e.detail.ratio > 1) {
        e.preventDefault()
      }
    },
    uniqueID(length) {
      var result = ''
      var chars =
        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
      for (var i = length; i > 0; --i)
        result += chars[Math.floor(Math.random() * chars.length)]
      return result
    },
    handleSetDataLayer(arr, id, data){
      if (Array.isArray(arr)) {
        arr.forEach(el => {
          if(el.id == id){
            data.forEach(e => {
              this.$set(el, e.name, e.value);
              this.context.model[e.name] = e.value
            });
          }else{
            if (Array.isArray(el.layers)) {
              this.handleSetDataLayer(el.layers, id, data)
            }
          }
        });
      }
      return arr;
    },
    OnMouseDownLeft(){
      this.startHold('MouseLeft', (step) => this.handleSetLeft(step));
    },
    OnMouseUpLeft(){
      this.stopHold('MouseLeft');
    },
    handleSetLeft(step){
      const s = (typeof step === 'number' && isFinite(step)) ? step : 1;
      let artworks = this.artworks();
      const arr = artworks[0].templates[0].layers;
      let layer = this.layer;
      let X = (this.layerX) - s;
      this.layerX = X;
      const data = [
        {
          name: 'x',
          value: X
        }
      ];
      this.handleSetDataLayer(arr, layer.id, data);
    },
    OnMouseDownRight(){
      this.startHold('MouseRight', (step) => this.handleSetRight(step));
    },
    OnMouseUpRight(){
      this.stopHold('MouseRight');
    },
    handleSetRight(step){
      const s = (typeof step === 'number' && isFinite(step)) ? step : 1;
      let artworks = this.artworks();
      let arr = artworks[0].templates[0].layers;
      let layer = this.layer;
      let X = (this.layerX) + s;
      this.layerX = X;
      const data = [
        {
          name: 'x',
          value: X
        }
      ];
      this.handleSetDataLayer(arr, layer.id, data);
    },
    OnMouseDownTop(){
      this.startHold('MouseTop', (step) => this.handleSetTop(step));
    },
    OnMouseUpTop(){
      this.stopHold('MouseTop');
    },
    handleSetTop(step){
      const s = (typeof step === 'number' && isFinite(step)) ? step : 1;
      let artworks = this.artworks();
      let arr = artworks[0].templates[0].layers;
      let layer = this.layer;
      let Y = (this.layerY) - s;
      this.layerY = Y;
      const data = [
        {
          name: 'y',
          value: Y
        }
      ];
      this.handleSetDataLayer(arr, layer.id, data);
    },
    OnMouseDownBottom(){
      this.startHold('MouseBottom', (step) => this.handleSetBottom(step));
    },
    OnMouseUpBottom(){
      this.stopHold('MouseBottom');
    },
    handleSetBottom(step){
      const s = (typeof step === 'number' && isFinite(step)) ? step : 1;
      let artworks = this.artworks();
      let arr = artworks[0].templates[0].layers;
      let layer = this.layer;
      let Y = (this.layerY) + s;
      this.layerY = Y;
      const data = [
        {
          name: 'y',
          value: Y
        }
      ];
      this.handleSetDataLayer(arr, layer.id, data);
    },
    SetZoom(value){
      let artworks = this.artworks();
      let arr = artworks[0].templates[0].layers;
      let layer = this.layer;
      const data = [
        {
          name: 'scaleX',
          value: Number(value)
        },
        {
          name: 'scaleY',
          value: Number(value)
        }
      ];
      this.handleSetDataLayer(arr, layer.id, data);
    },
    handleSetZoomMax(step){
      this.applyZoomStep(step, 1);
    },
    OnMouseUpZoomMax(){
      this.stopHold('MouseZoomMax');
    },
    OnMouseDownZoomMax(){
      this.startHold('MouseZoomMax', (step) => this.handleSetZoomMax(step));
    },
    handleSetZoomMin(step){
      this.applyZoomStep(step, -1);
    },
    OnMouseUpZoomMin(){
      this.stopHold('MouseZoomMin');
    },
    OnMouseDownZoomMin(){
      this.startHold('MouseZoomMin', (step) => this.handleSetZoomMin(step));
    },
     applyZoomStep(step, direction){
      const s = (typeof step === 'number' && isFinite(step)) ? step : 1;
      const MIN_SCALE = 0.05;
      const MAX_SCALE = 20;
      let artworks = this.artworks();
      let arr = artworks[0].templates[0].layers;
      let layer = this.layer;
      const rotation = Number(layer.rotation) || 0;
      const oldScaleX = Number(layer.scaleX) || 1;
      const oldScaleY = Number(layer.scaleY) || 1;
      let factor = Math.pow(1.01, direction * s);
      if(factor > 1){
        factor = Math.min(factor, MAX_SCALE / oldScaleX, MAX_SCALE / oldScaleY);
      }else if(factor < 1){
        factor = Math.max(factor, MIN_SCALE / oldScaleX, MIN_SCALE / oldScaleY);
      }
      const newScaleX = oldScaleX * factor;
      const newScaleY = oldScaleY * factor;
      const { dx, dy } = this.getCenterAnchorDelta(
        Number(layer.width), Number(layer.height),
        oldScaleX, oldScaleY, newScaleX, newScaleY,
        rotation, rotation
      );
      const newX = Number(layer.x) + dx;
      const newY = Number(layer.y) + dy;
      this.layerX = newX;
      this.layerY = newY;
      const data = [
        { name: 'scaleX', value: newScaleX },
        { name: 'scaleY', value: newScaleY },
        { name: 'x', value: newX },
        { name: 'y', value: newY }
      ];
      this.handleSetDataLayer(arr, layer.id, data);
    },
    startHold(idKey, applyStep){
      const start = performance.now();
      let last = start;
      const tick = (now) => {
        const elapsed = now - start;
        const dt = now - last;
        last = now;
        const speed = Math.min(1 + elapsed / 300, 6);
        applyStep(speed * (dt / 50));
        this[idKey] = requestAnimationFrame(tick);
      };
      this[idKey] = requestAnimationFrame(tick);
    },
    stopHold(idKey){
      cancelAnimationFrame(this[idKey]);
    },
    stopAllHolds(){
      ['MouseLeft', 'MouseRight', 'MouseTop', 'MouseBottom', 'MouseRotation', 'MouseZoomMax', 'MouseZoomMin']
        .forEach(idKey => this.stopHold(idKey));
    },
    getKeyFromUrl(url){
      const key_image = url.replace(ASSET_URL + '/', '');
      return key_image;
    },
    getImageSRC(key,width = '',unit = 'px',webp = true,trim = ''){
      var data = {key, width, unit, webp, trim }
      if (webp && !window.__WEBP) {
        data.webp = false
      }
      return `${CDN_URL}/${btoa(JSON.stringify(data))}`
    },
    async urlToBase64(url){
      const base64 = await axios.get(url, {
        responseType: 'arraybuffer'
      }).then(function (res){
        const bufftet = Buffer.from(res.data, 'binary').toString('base64');
        const base64 = 'data:image/png;base64,'+bufftet;
        return base64;
      });
      return base64;
    },
    async renderUrlToBase64(key){
      const getUrl = this.getImageSRC(key, "", 'px', true);
      const base64 = await this.urlToBase64(getUrl);
      return base64;
    },
    flipImage(base64Image) {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      const OnThis = this;
      const set = setInterval(async ()=> {
        var image = new Image();
        image.src = base64Image;
        const base64 = image.onload = function() {
          canvas.width = image.width;
          canvas.height = image.height;
          ctx.translate(image.width, 0);
          ctx.scale(-1, 1);
          ctx.drawImage(image, 0, 0);
          return canvas.toDataURL();
        }();
        if(base64.length > 10){
          clearInterval(set);
          const upload = await OnThis.upload(base64);
          const file = {
            id: OnThis.context.name,
            key: upload.key
          }
          OnThis.setIsSaveLocalstorage(true);
          OnThis.context.model = file;
          OnThis.syncModelGeometry();
          OnThis.urlFlip = ASSET_URL + '/' + upload.key
          OnThis.setLoadingForm(false);
        }
      });
    },
    async handleFlip(){
      this.setLoadingForm(true);
      this.defaultFlip = !this.defaultFlip;
      if(this.defaultFlip){
        const file = {
          id: this.context.name,
          key: this.getKeyFromUrl(this.urlNoneFlip)
        }
        this.setIsSaveLocalstorage(true);
        this.context.model = file;
        this.syncModelGeometry();
        this.setLoadingForm(false);
      }else {
        if(this.urlFlip === null){
          let key = null;
          if(this.urlNoneFlip){
            key = this.getKeyFromUrl(this.urlNoneFlip);
          }else if(this.context.model.key){
            key = this.context.model.key
          }else{
            return;
          }
          this.urlNoneFlip = ASSET_URL + '/' + key;

          const base64 = await this.renderUrlToBase64(key);
          this.flipImage(base64);
        }else {
          const file = {
            id: this.context.name,
            key: this.getKeyFromUrl(this.urlFlip)
          }
          this.setIsSaveLocalstorage(true);
          this.context.model = file;
          this.syncModelGeometry();
          this.setLoadingForm(false);
        }
      }
    },
    OnMouseDownRotation(){
      this.startHold('MouseRotation', (step) => this.handleSetRotation(step));
    },
    OnMouseUpRotation(){
      this.stopHold('MouseRotation');
    },
     getCenterAnchorDelta(width, height, oldScaleX, oldScaleY, newScaleX, newScaleY, oldRotation, newRotation){
      const degToRad = Math.PI / 180
      const rotatePoint = (x, y, deg) => {
        const rcos = Math.cos(deg * degToRad), rsin = Math.sin(deg * degToRad)
        return {x: x*rcos - y*rsin, y: x*rsin + y*rcos}
      }
      const halfW = width / 2
      const halfH = height / 2
      const oldOffset = rotatePoint(halfW * oldScaleX, halfH * oldScaleY, oldRotation)
      const newOffset = rotatePoint(halfW * newScaleX, halfH * newScaleY, newRotation)
      return {
        dx: oldOffset.x - newOffset.x,
        dy: oldOffset.y - newOffset.y
      };
    },
    handleSetRotation(step){
      const s = (typeof step === 'number' && isFinite(step)) ? step : 1;
      let artworks = this.artworks();
      let arr = artworks[0].templates[0].layers;
      let layer = this.layer;
      const oldRotation = Number(layer.rotation);
      const newRotation = oldRotation - s;
      const scaleX = Number(layer.scaleX) || 1;
      const scaleY = Number(layer.scaleY) || 1;
      const { dx, dy } = this.getCenterAnchorDelta(
        Number(layer.width), Number(layer.height),
        scaleX, scaleY, scaleX, scaleY,
        oldRotation, newRotation
      );
      const newX = Number(layer.x) + dx;
      const newY = Number(layer.y) + dy;
      this.rotationValue = newRotation;
      this.layerX = newX;
      this.layerY = newY;
      const data = [
        {
          name: 'rotation',
          value: newRotation
        },
        {
          name: 'x',
          value: newX
        },
        {
          name: 'y',
          value: newY
        }
      ];
      this.handleSetDataLayer(arr, layer.id, data);
    },
  }
}
</script>

<style>
.Modal_crop_box > div  {
  overflow: auto !important;
}
.Modal_crop_box > div::-webkit-scrollbar {
  width: 6px;
  background-color: #F5F5F5;
}
.Modal_crop_box > div::-webkit-scrollbar-thumb {
  background-color: #341a1a;
}

.Modal_ask_box .vm--modal {
  top: 10px !important;
}

@media only screen and (max-width: 739px){
  .Modal_crop_box .vm--modal{
    top: 0px !important;
    height: 100vh !important;
    bottom: 0 !important;
    background: white !important;
    padding: 10px;
  }
  .Modal_box.model-cut-face .vm--modal{
    position: absolute !important;
    top: 0 !important;
    bottom: 0;
    border-radius: 0px !important;
  }
  .Abn-modal-close {
    z-index: 9999999;
    display: none !important
  }
  .Modal_ask_box .vm--modal{
    width: 96% !important;
    margin: auto;
  }
  .Modal_ask_box .vm--modal {
    top: 30% !important;
  }

  .Abn-modal-footer-div {
    display: flex;
  }

  .Abn-modal-crop {
    margin-top: 20px !important;
  }

  .Abn-modal-footer-div > button {
    border-radius: 5px;
  }
}
</style>

<style scoped>

input[type='file'] {
  display: none;
}

.custom-image {
  width: 100px;
  height: 80px;
  object-fit: contain;
  box-shadow: rgb(0 0 0 / 20%) 0px 0px 2px 1px;
  border-radius: 3px;
  border: 3px solid var(--primary-color, #5c6ac4);
  cursor: pointer;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.custom-image img{
  width: 100%;
}

.message-text-loading {
  color: #e1e1e1;
  font-weight: 500;
  text-shadow: 0px 0px 5px #0000007d;
}

img.custom-image {
  width: 100px;
  height: 80px;
  object-fit: contain;
  box-shadow: rgb(0 0 0 / 20%) 0px 0px 2px 1px;
  border-radius: 3px;
  border: 3px solid var(--primary-color, #5c6ac4);
  cursor: pointer;
}
.copper-wrapper {
  display: grid;
  grid-template-columns: auto 120px;
}
.modal-wrapper {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 100%;
  /* grid-template-rows: auto 40px; */
}
.modal-wrapper .cropper-wrapper {
  overflow: hidden;
  margin-bottom: 10px;
}

.Abn-modal-crop{
  overflow: auto ;
  width: 600px;
  max-width: 100%;
  margin: 0 auto;
  margin-top: 2px;
  padding: 5px;
}


.Abn-modal-close {
  background: #6e6e6f;
  width: 50px;
  height: 50px;
  text-align: center;
  color: white;
  font-weight: 900;
  position: absolute;
  right: 0;
  font-size: 18px;
  display: flex;
  top: 0px;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  z-index: 9999999999999999999999;
}

.modal-wrapper .cropper-wrapper::-webkit-scrollbar {
  width: 6px;
  background-color: #F5F5F5;
}

.modal-wrapper .cropper-wrapper::-webkit-scrollbar-thumb {
  background-color: #341a1a;
}

.Modal_crop_box.vm--container > div > div{
  overflow: auto !important;
}


.Abn-modal-footer{
  display: flex;
  justify-content: space-between;
}

button.btn.Abn-btn-cancel {
  background: #7b7b7e !important;
  color: white !important;
  font-weight: 600 !important;
  width: 49%;
  float: left;
}

button.btn.Abn-btn-apply {
  background: none 0% 0% / auto repeat scroll padding-box border-box rgb(33 171 43) !important;
  color: white !important;
  font-weight: 600 !important;
  width: 49%;
  float: left;
}

.Abn-modal-footer {
  position: sticky;
  bottom: 0px;
  left: 0;
  right: 0;
  background: #ffffff;
}

.Abn-modal-footer-div{
  width: 600px;
  max-width: 100%;
  margin: auto;
  background: #ffffff;
  padding: 10px 0;
}

.Modal_box.model-cut-face .Abn-modal-footer-div{
  width: 650px !important;
  max-width: 100%;
  margin: auto;
  background: #ffffff;
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
}

.Abn-modal-footer-div > button{
  margin: 0 2px;
}

.message-loading-group {
  position: fixed !important;
  top: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  background: #5b5b5b87 !important;
  z-index: 9999999999999999 !important;
}

.message-loading-div {
  margin: 0 auto !important;
  width: 100% !important;
  text-align: center !important;
  position: absolute !important;
  top: 50% !important;
}


.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}


.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.Abn-Image-shape{
  position: relative;
  margin-top: 7px ;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
  background: darkcyan;
}

.Abn-Image-shape:after {
  content: "";
  display: block;
}

.Abn-Image-shape-image-crop{
  width: 100%;
}

.Abn-Image-shape-url{
  width: 100%;
  height: 100%;
  pointer-events: none;
  opacity: 0.7;
  position: absolute;
  top: 0;
  bottom: 0;
}


.preview {
  width: 100%;
  height: calc(372px * (9 / 16));
  overflow: hidden;
}

@media only screen and (max-width: 739px){
  .Abn-modal-footer {
    position: fixed !important;
    bottom: 0;
    left: 0;
    right: 0;
  }
}

.Abn-box-image-shape-cropper{
  float: left;
  width: 100%;
}

.Abn-box-image-shape-cropper-preview{
  float: right;
  width: 40%;
}

section.preview-area {
  display: flex;
  position: relative;
}

.image-preview-box-crop-url{
  position: absolute;
  z-index: 999;
  right: 0;
  left: 0;
  opacity: 0.8;
}


.v-ion-abn{
  width: 16px;
  padding: 0;
  margin: 0;
}


.choose_image_shape_active {
  background: #26bf31 !important;
  border: 1px solid #26bf31 !important;
  animation-name: animation_button_active;
  animation-duration: 2s;
}

.hdev-shape-image-dom {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}


@keyframes choose_image_shape_active {
  from {opacity: 0.1;}
  to {opacity: 1;}
}


.v-ion-abn{
  width: 30px;
  padding: 0;
  margin: 0;
}

button.btn.btn-upload-new {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100px;
  border: 1px solid #bdbbbb;
  line-height: 1;
  font-size: 14px;
  height: 80px;
}

.group-button-image {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.group-button-image > * {
  margin: 0 5px;
}


.box-container-modal-cutface {
  width: 650px;
  margin: auto;
  max-width: 95%;
  position: relative;
  padding: 10px 0;
}

.model-cut-face{
  z-index: 9999999999 !important
}


.box-setting-cut-face_column__item{
  position: absolute;
  right: -75px;
  top: 10px;
  background: #fff;
  border: 1px solid #969699;
  border-radius: 5px;
  padding: 3px;
  text-align: center;
}
.box-position-adjustment {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.box-active-image-cut-face{
  position: relative;
}
button.btn.btn-settting-cut-face {
  position: absolute;
  bottom: 2px !important;
  right: 2px !important;
  background: #fff;
  color: #686b5a;
  padding: 3px !important;
  height: 30px !important;
  width: 30px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center;
  border-radius: 3px !important;
  margin: 0 !important;
  min-height: 30px !important;
  max-height: 30px !important;
  min-width: 30px !important;
  max-width: 30px !important;
}

.box-position-adjustment > button{
  margin-bottom: 5px;
}

button.btn.btn-settting-cut-face {
  position: absolute;
  bottom: 2px !important;
  right: 2px !important;
  background: #fff;
  color: #686b5a;
  padding: 3px !important;
  height: 30px !important;
  width: 30px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center;
  border-radius: 3px !important;
  margin: 0 !important;
  min-height: 30px !important;
  max-height: 30px !important;
  min-width: 30px !important;
  max-width: 30px !important;
}

.preview-print{
  width: 100%;
  height: max-content;
  position: relative
}

.box-setting-cut-face {
  width: 100%;
  padding: 0px 0px;
  background: #fff;
  position: absolute;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;}


.box-setting-cut-face > div {
  width: 49%;
}
button.btn.btn-flip-face {
  background: #686b5a;
  color: #fff;
  font-weight: 300;
  height: 45px !important;
  width: 45px;
  max-width: 45px;
  min-width: 45px;
  min-height: 45px;
  max-height: 45px;
  margin: 2px auto !important;
  padding: 8px 0;
  border-radius: 4px;
  line-height: 0;
}
.box-setting-cut-face__item:nth-last-child(1) {
  margin-bottom: 0px;
}
.box-modal-ask {
  padding: 10px 20px;
  position: relative;
}

.box-modal-ask-close{
  position: absolute;
  right: 20px;
  background: #6e6e6f;
  height: 25px;
  width: 25px;
  display: flex;
  color: #ffffff;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  cursor: pointer;
  transition: 0.6s;
}

.box-modal-ask-close:hover{
  background: red;
}
.modal-ask-text{
  text-align: center;
  margin-bottom: 30px;
  margin-top: 20px;
  font-size: 17px;
}
.group_ask_button > button{
  background: #686B5A;
  color: white !important;
  font-weight: 600 !important;
  width: 49%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px;
  border-radius: 3px;
}
.group_ask_button>button > svg {
  margin-right: 5px;
}
.group_ask_button .btn_ask_edit{
  background: #d26e4b !important;
}
.group_ask_button {
  display: flex;
  justify-content: space-between;
}


@media only screen and (max-width: 739px){
  .box-setting-cut-face_column__item {
    position: relative !important;
    right: 0 !important;
    top: 0 !important;
    border: none;
    text-align: left;
  }
  .preview-print{
    width: 95%;
    margin: auto;
    height: max-content;
    position: relative
  }
  .box-position-adjustment>button.btn.btn-flip-face{
    margin: 5px !important;
  }
  .box-position-adjustment {
    display: flex;
    flex-direction: row !important;
    justify-content: flex-start;
  }
  .box-setting-cut-face {
    position: relative !important;
    padding: 5px !important;
    display: flex;
    flex-direction: column;
  }
  .box-setting-cut-face > div {
    width: 100% !important;
  }
  .box-controller-mobile{
    position: sticky;
    bottom: 55px;
  }
  .box-setting-cut-face_column__item > div {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }
  .box-setting-cut-face_column__item label{
    display: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Formulate/ImageRemoveBackground.vue